const communities = [
	{
		path: '/community/communities',
		name: 'community-communities-list',
		component: () => import('@/views/community/communities/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/communities/:id',
		name: 'community-communities-detail',
		component: () => import('@/views/community/communities/detail.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
]

export default communities
